module.exports = __webpack_public_path__ + "static/tekstura-5c82e8b9ecef098dc966e7fd82f6fdb4.jpg";